/* global embedded_svc */
import { html } from '@utilities/dom-elements';
import Cookies from '@components/cookies';
import Events from "@utilities/events";

const HOOK_CONFIG = '[js-hook-chat-config]';
const HOOK_TRIGGER_BUTTON = '[js-hook-open-chat]';
const HOOK_TRIGGER_BUTTON_EXT ='[js-hook-open-chat-ext]';
const HOOK_COOKIE_WARNING = '[js-hook-chat-cookie-warning]';
const HIDDEN_CLASS = 'u-hidden';

class Chat {
  constructor(element) {
    this.element = element;
    this.configEl = this.element.querySelector(HOOK_CONFIG);
    this.buttons = [...document.querySelectorAll(HOOK_TRIGGER_BUTTON)];
    this.buttonsExt = [...document.querySelectorAll(HOOK_TRIGGER_BUTTON_EXT)];
    this.invalidCookies = !Cookies.cookieIsValid(Cookies.cookieName.advertising);

    if(this.buttonsExt.length > 0){
      this.bindButtonEventsEXT();
    }

    if(!this.configEl){
      return;
    }

    this.config = {
      language: html.lang,
      buttonName: this.configEl.dataset.buttonName,
      buttonId: this.configEl.dataset.buttonId,
      eswLiveAgentDevName: this.configEl.dataset.agentName,
      extraPrechatFormDetails: {
        country: this.element.dataset.userCountry,
        region: this.element.dataset.userRegion,
        language: this.element.dataset.userLanguage,
      }
    }

    if (!this.invalidCookies && this.element.dataset.load === 'true') this.addScript();

    this.bindEvents();
    this.bindButtonEvents();
  }

  static openChat() {
    const button = document.querySelector('.embeddedServiceHelpButton button');
    if (button) button.click();
  }

  static showCookieWarning(originButton) {
    originButton.parentElement.querySelector(HOOK_COOKIE_WARNING).classList.remove(HIDDEN_CLASS);
  }

  bindEvents() {
    Events.$on('chat::reinit-buttons', () => this.reinitButtons());
  }

  bindButtonEvents() {
    this.buttons.forEach(button => {
      button.addEventListener('click', () => {
        if (this.isLoaded) {
          Chat.openChat();
        } else {
          this.addScript(true, button);
        }
      });
    });
  }

  bindButtonEventsEXT() {
    this.buttonsExt.forEach(buttonExt => {
      buttonExt.addEventListener('click', () => {
          Chat.openChat();
      });
    });
  }

  addScript(openChat) {
    this.isLoaded = true;

    const jsFile = document.createElement('script');
    jsFile.type = 'text/javascript';
    jsFile.src = 'https://service.force.com/embeddedservice/5.0/esw.min.js';
    jsFile.setAttribute('async', '');
    jsFile.setAttribute('defer', '');
    jsFile.onload = () => {
      this.initChat(openChat);
    };

    document.getElementsByTagName('head')[0].appendChild(jsFile);
  }

  initChat(openChat) {
    /**
     * Chat config based on what we received from the customer
     * Keep commented out code for future reference
     */
    const initESW = (gslbBaseURL) => {
      embedded_svc.settings.displayHelpButton = true;
      embedded_svc.settings.language = this.config.language;

      // embedded_svc.settings.defaultMinimizedText = 'Chat'; // (Defaults to Chat with an Expert)
      // embedded_svc.settings.disabledMinimizedText = ''; // (Defaults to Agent Offline)

      // embedded_svc.settings.loadingText = ''; // (Defaults to Loading)
      // embedded_svc.settings.storageDomain = 'yourdomain.com'; //(Sets the domain for your deployment so that visitors can navigate subdomains during a chat session)

      // Settings for Chat
      // embedded_svc.settings.directToButtonRouting = function(prechatFormData) {
      // Dynamically changes the button ID based on what the visitor enters in the pre-chat form.
      // Returns a valid button ID.
      // };
      // Sets the auto-population of pre-chat form fields
      // embedded_svc.settings.prepopulatedPrechatFields = {

      // };
      // embedded_svc.settings.fallbackRouting = []; //An array of button IDs, user IDs, or userId_buttonId
      // embedded_svc.settings.offlineSupportMinimizedText = 'Chat'; // (Defaults to Contact Us)

      embedded_svc.settings.enabledFeatures = ['LiveAgent'];
      embedded_svc.settings.entryFeature = 'LiveAgent';

      embedded_svc.settings.extraPrechatInfo = [{
        'entityFieldMaps': [{
          'doCreate': true,
          'doFind': true,
          'fieldName': 'LastName',
          'isExactMatch': true,
          'label': 'Last Name'
        }, {
          'doCreate': true,
          'doFind': true,
          'fieldName': 'FirstName',
          'isExactMatch': true,
          'label': 'First Name'
        }, {
          'doCreate': true,
          'doFind': true,
          'fieldName': 'Email',
          'isExactMatch': true,
          'label': 'Email'
        }],
        'entityName': 'Contact',
        'showOnCreate': false
      }];

      embedded_svc.settings.extraPrechatFormDetails = [{
        'label': 'Country',
        'value': this.config.extraPrechatFormDetails.country,
        'transcriptFields': ['Country__c'],
        'displayToAgent': true
      }, {
        'label': 'Region',
        'value': this.config.extraPrechatFormDetails.region,
        'transcriptFields': ['Region__c'],
        'displayToAgent': true
      }, {
        'label': 'Language',
        'value': this.config.extraPrechatFormDetails.language,
        'transcriptFields': ['Language__c'],
        'displayToAgent': true
      }];

      embedded_svc.init(
        'https://tfour.my.salesforce.com',
        'https://tfour.force.com',
        gslbBaseURL,
        '00D2p000000P6Rt',
        this.config.buttonName,
        {
          baseLiveAgentContentURL: 'https://c.la1-c2-fra.salesforceliveagent.com/content',
          deploymentId: '5722p000000HCUY',
          buttonId: this.config.buttonId,
          baseLiveAgentURL: 'https://d.la1-c2-fra.salesforceliveagent.com/chat',
          eswLiveAgentDevName: this.config.eswLiveAgentDevName,
          isOfflineSupportEnabled: false
        }
      );
    };


    if (window.embedded_svc) {
      initESW('https://service.force.com');

      if (openChat) {
        setTimeout(() => {
          Chat.openChat();
        }, 1000);
      }
    } else {
      console.error('Failed to load chat script');
    }
  }

  reinitButtons() {
    this.buttons = [...document.querySelectorAll(HOOK_TRIGGER_BUTTON)];

    this.bindButtonEvents();
  }
}

export default Chat;
